/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { css } from 'styled-components';
import BaseLayout from '../common/layouts/BaseLayout';
import HeadShared from '../common/HeadShared';
import HeroLanding from '../common/layouts/heroLanding';
import { Container, Padding, Margin } from '../common/base';
import { Grid, Col } from '../common/interfaces';
import { LegalSubtitle, LegalDesc, LegalHeader, LegalList } from './Styled';
import { Trans } from '../common/libs/i18n';

const TermsAndConditionsDocument = () => (
  <BaseLayout headerType="red">
    <HeadShared title="RupiahToken - Terms And Conditions" desc="Terms And Conditions" />
    <HeroLanding title="Terms And Conditions" />
    <div
      css={css`
        background-color: ${({ theme: { colors } }) => colors.light.primary};
      `}
    >
      <Container>
        <Padding vertical={80}>
          <Grid justify="center">
            <Col lg={8} sm={12}>
              <Margin bottom={60}>
                <Trans i18nKey="rupiahtoken.terms_and_condition_document">
                  <h2>Rupiah Token Term and Conditions</h2>
                  <LegalSubtitle>Last updated: June 20, 2019</LegalSubtitle>
                  <LegalDesc>
                    <p>
                      Please read these&nbsp;
                      <b>Terms and Conditions</b>
                      &nbsp;and our&nbsp;
                      <a href="./privacy">Privacy Policy</a>
                      &nbsp;(collectively the “Terms”) carefully, as you agree that you consent to
                      these Terms by using RupiahToken's services. For any questions, please contact
                      us at&nbsp;
                      <a href="mailto:support@rupiahtoken.com">support@rupiahtoken.com</a>
                    </p>
                    <Margin top={24} />
                    <LegalHeader>Acceptance of the Terms and Conditions</LegalHeader>
                    <p>
                      These&nbsp;
                      <b>Terms and Conditions</b>
                      &nbsp;are entered into by and between you and PT Rupiah Token Indonesia
                      (“Company,” "IDRT", "RupiahToken", “we,” “our,” or “us”), and they govern your
                      access to and use of our online software platform (the “Platform”), whether as
                      a guest or a registered user.&nbsp;
                      <br />
                      <br />
                      By using the Platform, or by clicking to accept or agree to the&nbsp;
                      <b>Terms and Conditions</b>
                      &nbsp;when this option is made available to you, you accept and agree to be
                      bound and abide by these&nbsp;
                      <b>Terms and Conditions</b>
                      &nbsp;and our Privacy Policy, incorporated herein by reference.
                      <b>
                        If you do not agree to these Terms and Conditions or the Privacy Policy, do
                        not access or use the Platform or any RupiahToken services.
                      </b>
                    </p>
                    <Margin top={24} />
                    <LegalHeader>RupiahToken Services</LegalHeader>
                    <p>
                      The Platform is an online environment to Purchase RupiahToken ("IDRT"), a
                      digital token on the blockchain that is backed by Fiat Rupiah (IDR) currency.
                      You may also redeem IDRT for fiat IDR currency on the Platform. IDRT is not
                      money, legal tender, nor monetary instruments. Once you have IDRT tokens, you
                      can trade them, keep them, or use them to pay persons that accept IDRT tokens,
                      or redeem IDRT for fiat IDR currency on the Platform.
                      <br />
                      <br />
                      IDRT is backed by the fiat currency deposit used to purchase at issuance. IDRT
                      holders can redeem the token for actual fiat rupiah currency (IDR) through the
                      Platform. The Platform is only intended to facilitate such purchases and
                      redemptions.
                      <br />
                      <br />
                      The Company reserves the right to refuse to issue or redeem IDRT if any act,
                      conduct, transaction, omission, or misrepresentation, or the party requesting
                      the issuance or redemption, violates, attempts to violate, causes, aids, or
                      abets the violation of any applicable laws, statutes, ordinances, or
                      regulations; is suspected or believed to be blocked property, frozen assets,
                      or economic resources, or the proceeds of any crime, terrorist financing, or
                      corruption related to any person or government official under any applicable
                      laws; or exposes the Company to sanctions, restrictions, or penalties.
                    </p>
                    <Margin top={24} />
                    <LegalHeader>Anti-Money Laundering and Counter-Terrorist Financing</LegalHeader>
                    <p>
                      We reserve the right to refuse registration to, or to bar transactions from or
                      to, anyone from or in jurisdictions that do not meet international AML–CTF
                      standards as set out by the FATF; to anyone that is a Politically Exposed
                      Person within the meaning of the FATF’s 40 Recommendations; or, that fails to
                      meet any of our customer due diligence standards, requests, or requirements.
                      At all times, you may be subject to enhanced customer due diligence procedures
                      in your use of the Platform and any related service. The Company will validate
                      and verify your identity based on the information provided. As part of our
                      Know Your Customer (KYC) policy and ongoing monitoring of account activity, we
                      may request additional information and documentation from you in the future.
                      If we are unable to contact you and verify your identity in the future, we may
                      need to close your account.
                      <br />
                      <br />
                      The Company will cooperate with applicable law enforcement and regulatory
                      authorities where it is required to do so and will share information if there
                      are reasonable grounds to believe that IDRT is being used for illegal
                      purposes.
                      <br />
                      <br />
                      Any exchange that lists IDRT represents and warrants to the Company that by
                      doing so it is duly organized, registered, licensed, and shall comply with all
                      applicable laws and rules in every jurisdiction in which it operates.
                      Furthermore, any exchange listing IDRT represents and warrants to the Company
                      that by doing so it has Anti-Money Laundering (“AML”) and Counter Terrorist
                      Financing controls meeting the requirements in every jurisdiction in which it
                      operates.
                    </p>
                    <Margin top={24} />
                    <LegalHeader>Accessing the Platform</LegalHeader>
                    <p>
                      We reserve the right to amend the Platform, and any service or material we
                      provide on the Platform, in our sole discretion without notice. This includes,
                      but is not limited to, replacing the existing IDRT smart contracts with new
                      smart contracts or moving any IDRT token to a new blockchain. In order to
                      Purchase or Redeem IDRT, you must be a verified customer of the Company. You
                      must create an account on the Platform and pass any KYC/AML validation
                      requirements that we or our independent fiduciary partners require. It is a
                      condition of your use of the Platform that information you enter into the
                      Platform your account is correct, current, and complete. All information you
                      enter into the Platform is governed by our Privacy Policy.
                      <br />
                      <br />
                      We reserve the right to deny access to the Platform to anyone or cancel an
                      account for any or no reason, including but not limited to violations of our
                      Terms and Conditions, applicable laws and regulations, or engaging in any
                      Prohibited Uses, and at any time, at our sole discretion. If we terminate your
                      account for any reason, we’ll provide you with notice of our actions and make
                      any unrestricted IDRT tokens available for redemption.
                      <br />
                      <br />
                      We reserve the right to prohibit wire submissions of fiat currency or
                      redemption requests of IDRT if the total amount submitted or requested is less
                      than 500.000 IDR, although we may in practice lower the minimum requirement
                      limit.
                    </p>
                    <Margin top={24} />
                    <LegalHeader>Account Security</LegalHeader>
                    <p>
                      You are solely responsible for maintaining the confidentiality of your account
                      information, as well as any and all activities that occur under your account.
                      You must immediately notify us of any unauthorized use of your account and any
                      other such security breach. We will not be liable for any loss that may occur
                      as a result of someone else using your account or password, with or without
                      your knowledge. You should use particular caution when accessing your account
                      from a public or shared computer so that others are not able to view or record
                      your password or other personal information. We have the right to disable any
                      account at any time in our sole discretion if, in our opinion, you have
                      violated any provision of these&nbsp;
                      <b>Terms and Conditions</b>
                      .&nbsp;
                    </p>
                    <Margin top={24} />
                    <LegalHeader>Fees and Taxes </LegalHeader>
                    <p>
                      The Company does not take any responsibility for any bank transfer, wire, or
                      any other fees or costs (“Fees”) associated with the purchase or redemption of
                      any IDRT product. Any Fees incurred by you during the purchase or redemption
                      of IDRT shall be deducted from the amount being purchased or redeemed before
                      the balance is transferred to you. You are also responsible for all on-chain
                      transaction costs associated with on-chain transfers of IDRT, such as paying
                      Ether for gas.
                      <br />
                      <br />
                      You are solely liable for all the taxes, fees, and commissions resulting from
                      the use of the Platform. These 
{' '}
<b>Terms and Conditions</b>
{' '}
alone do not create
                      a joint venture, partnership, or principal-agent relationship between you and
                      the Company, or any other users, and nothing in these
{' '}
                      <b>Terms and Conditions</b>
{' '}
may be used to imply such a relationship. You
                      agree to indemnify the Company from any liability for, or assessment of, any
                      claims or penalties with respect to such taxes, labor, or employment
                      requirements, including any liability for, or assessment of taxes imposed on
                      the Company by the relevant taxing authorities with respect to any fees paid
                      to you as the result of using the Platform.
                    </p>
                    <Margin top={24} />
                    <LegalHeader>Assumption of Risk; No Advice </LegalHeader>
                    <p>
                      The Company does not provide any investment advice. The information contained
                      within the Platform is for informational purposes only, and the Company is not
                      soliciting any action based upon such materials. The material is not to be
                      construed as investment advice. We do not provide any consultation on the
                      advisability of purchasing any IDRT, the timing of a purchase or redemption,
                      or any other matters regarding the purchase or redemption of IDRT such as
                      trading techniques, models, algorithms, or any other schemes. Additionally,
                      the material accessible through the Platform does not constitute a
                      representation that the purchase of IDRT are suitable or appropriate for you.
                    </p>
                    <Margin top={24} />
                    <LegalHeader>Risks </LegalHeader>
                    <p>
                      <h5>Not a Bank Account</h5>
                      Your account with us (and any available assets held in such account) is not a
                      bank account or a deposit account. IDRT is not a financial instrument and the
                      Company may not be regulated as a financial institution in your jurisdiction.
                      No interest will be paid on any funds or other assets held in your account and
                      all assets directly held by the Company are not insured by the Company or,
                      except as set forth below, any third party or any government agency. The
                      Company may collect interest on the fiat deposits held in the IDRT collateral
                      bank account.
                      <br />
                      <br />
                      <h5>Irreversible Transactions</h5>
                      As with all Blockchain transactions, IDRT transactions (which occur on top of
                      Ethereum network) is irreversible, and, accordingly, losses due to fraudulent
                      or accidental transactions may not be recoverable.
                      <br />
                      <br />
                      <h5>Redemption of IDRT</h5>
                      All IDRT will be rounded down to the nearest Rupiah for redemption.
                    </p>
                    <Margin top={24} />
                    <LegalHeader>Intellectual Property Rights</LegalHeader>
                    <p>
                      The Platform and its entire contents, features, and functionality (including
                      but not limited to all information, software, text, displays, images, video
                      and audio, and the design, selection, and arrangement thereof), are owned by
                      the Company, its licensors, or other providers of such material and are
                      protected by Indonesian and international copyright, trademark, patent, trade
                      secret, and other intellectual property or proprietary rights laws.
                      <br />
                      <br />
                      These&nbsp;
                      <b>Terms and Conditions</b>
                      &nbsp;permit you to use the Platform for your use only, subject to the
                      following restrictions:
                      <LegalList>
                        <li>
                          You must not reproduce, distribute, modify, create derivative works of,
                          publicly display, publicly perform, republish, download, store, or
                          transmit any of the material on the Platform, except as it is created and
                          owned by you
                        </li>
                        <li>
                          You must not delete or alter any copyright, trademark, or other
                          proprietary rights notices from copies of materials from this site
                        </li>
                        <li>
                          No right, title, or interest in or to the Platform or any content on the
                          Platform is transferred to you, and all rights not expressly granted are
                          reserved by the Company
                        </li>
                      </LegalList>
                    </p>
                    <Margin top={24} />
                    <LegalHeader>Links from the Platform</LegalHeader>
                    <p>
                      Links to any third-party websites on the Platform are provided for your
                      convenience only. We have no control over the contents of those sites or
                      resources. If you decide to access any of the third-party websites linked to
                      the Platform, you do so entirely at your own risk and subject to the terms and
                      conditions of use for such websites.
                    </p>
                    <Margin top={24} />
                    <LegalHeader>Reliance on Information Posted</LegalHeader>
                    <p>
                      We do not warrant the accuracy, completeness, or usefulness of any information
                      on the Platform. Any reliance you place on such information is strictly at
                      your own risk. We disclaim all liability and responsibility arising from any
                      reliance placed on such materials by you or any other visitor to the Platform,
                      or by anyone who may be informed of any of its contents. The Platform includes
                      content provided by third parties, including materials provided by other
                      users, attorneys, third-party licensors, syndicators, aggregators, and/or
                      reporting services. All statements and/or opinions expressed in these
                      materials, other than the content provided by the Company, are solely the
                      opinions and the responsibility of the person or entity providing those
                      materials. We are not responsible, or liable to you or any third party, for
                      the content or accuracy of any materials provided by any third parties.
                    </p>
                    <Margin top={24} />
                    <LegalHeader>Users Outside of Indonesia</LegalHeader>
                    <p>
                      The Platform is controlled and operated from Indonesia and is subject to its
                      laws. If you choose to access the Platform outside of Indonesia, you do so at
                      your own risk and are responsible for complying with all applicable laws,
                      rules, and regulations.
                    </p>
                    <Margin top={24} />
                    <LegalHeader>Limitation on Liability</LegalHeader>
                    <p>
                      IN NO EVENT WILL THE COMPANY, ITS AFFILIATES, OR THEIR LICENSORS, SERVICE
                      PROVIDERS, EMPLOYEES, AGENTS, OFFICERS, OR DIRECTORS BE LIABLE FOR DAMAGES OF
                      ANY KIND, UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN CONNECTION WITH YOUR
                      USE, OR INABILITY TO USE, THE PLATFORM, ANY WEBSITES LINKED TO IT, ANY CONTENT
                      ON THE PLATFORM, OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE PLATFORM,
                      INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, OR
                      PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO, PERSONAL INJURY, PAIN AND
                      SUFFERING, EMOTIONAL DISTRESS, LOSS OF REVENUE, LOSS OF PROFITS, LOSS OF
                      BUSINESS, OR ANTICIPATED SAVINGS, LOSS OF USE, LOSS OF GOODWILL, LOSS OF DATA,
                      AND WHETHER CAUSED BY TORT (INCLUDING NEGLIGENCE), BREACH OF CONTRACT, OR
                      OTHERWISE, EVEN IF FORESEEABLE.
                      <br />
                      <br />
                      IN NO EVENT WILL THE COLLECTIVE LIABILITY OF THE COMPANY AND ITS SUBSIDIARIES
                      AND AFFILIATES, AND THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS,
                      OFFICERS, AND DIRECTORS, TO ANY PARTY (REGARDLESS OF THE FORM OF ACTION,
                      WHETHER IN CONTRACT, TORT OR OTHERWISE) EXCEED THE AMOUNT YOU HAVE PAID TO THE
                      COMPANY FOR THE APPLICABLE SERVICES IN THE LAST 12 MONTHS OUT OF WHICH
                      LIABILITY AROSE. THE FOREGOING DOES NOT AFFECT ANY LIABILITY WHICH CANNOT BE
                      EXCLUDED OR LIMITED UNDER APPLICABLE LAW.
                    </p>
                    <Margin top={24} />
                    <LegalHeader>Indemnification</LegalHeader>
                    <p>
                      You agree to defend, indemnify, and hold harmless the Company, its affiliates,
                      licensors, and service providers, and its and their respective officers,
                      directors, employees, contractors, agents, licensors, suppliers, successors,
                      and assigns from and against any claims, liabilities, damages, judgments,
                      awards, losses, costs, expenses, or fees (including reasonable attorneys’
                      fees) (collectively “Claims”) arising out of or relating to: (i) your
                      violation of these Terms and Conditions; (ii) your use of the Platform, or
                      (iii) your purchase or redemption of any IDRT.
                    </p>
                    <Margin top={24} />
                    <LegalHeader>Changes to the Terms and Conditions and Platform</LegalHeader>
                    <p>
                      We will likely change and update these Terms from time to time, and these
                      changes are effective as soon as we post them on the Platform. If you continue
                      to use the Platform following the posting of any revised Terms, you are
                      accepting and agreeing to the changes. From time to time, we may also update
                      the content on the Platform as we see fit, but do not guarantee that any
                      content is necessarily complete or up-to-date.
                    </p>
                    <Margin top={24} />
                    <LegalHeader>Feedback</LegalHeader>
                    <p>
                      All feedback, comments, requests for technical support and other
                      communications relating to the Platform should be directed to&nbsp;
                      <a href="mailto:support@rupiahtoken.com">support@rupiahtoken.com</a>
. In the
                      event that you provide us any ideas, thoughts, criticisms, suggested
                      improvements, or other feedback related to Platform (collectively “Feedback”),
                      you agree that we may use the Feedback in any way we deem appropriate to: (a)
                      improve our Platform and (b) promote the Platform, and that you will not be
                      due any compensation for your Feedback that is used in these ways.
                    </p>
                  </LegalDesc>
                </Trans>
              </Margin>
            </Col>
          </Grid>
        </Padding>
      </Container>
    </div>
  </BaseLayout>
);

export default TermsAndConditionsDocument;
